export * from 'SourceComponent/Router/Router.config.js';
export const AGE_VERIFICATION = 'AGE_VERIFICATION';
